module.exports = __webpack_public_path__ + "img/button-smiley.21124a2f.png";